import HomePage from '@pages/index';
import LiquidityPage from '@pages/liquidity';
import LotteryPage from '@pages/lottery';
import PortfolioPage from '@pages/portfolio/PoolAnalytics';
import PortfolioLuckyBagsPage from '@pages/portfolio/PortfolioLuckyBags';
import PortfolioStakeAnalyticsPage from '@pages/portfolio/PortfolioStakeAnalytics';
import StakePage from '@pages/stake';
import StakeLockPage from '@pages/stakeLock';
import SwapPage from '@pages/swap';
import AssetPage from '@pages/loan';
import DepositPage from '@pages/loan/DepositPage';
import BorrowPage from '@pages/loan/BorrowPage';
import WithdrawPage from '@pages/loan/WithdrawPage';
import RepayPage from '@pages/loan/RepayPage';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import tifiRoutes, { BASE_PATH } from './tifiRoutes';

const AppRoutes: React.FC<{}> = () => {
  return (
    <Routes>
      <Route path={tifiRoutes.HOME} element={<HomePage />}></Route>
      <Route path={tifiRoutes.SWAP} element={<SwapPage />}></Route>
      <Route path={tifiRoutes.STAKE} element={<StakePage />}></Route>
      <Route path={tifiRoutes.STAKE_LOCK} element={<StakeLockPage />}></Route>
      <Route
        path={tifiRoutes.PORTFOLIO_POOL}
        element={<PortfolioPage />}
      ></Route>
      <Route
        path={tifiRoutes.PORTFOLIO_STAKE}
        element={<PortfolioStakeAnalyticsPage />}
      ></Route>
      <Route
        path={tifiRoutes.PORTFOLIO_LUCKYBAGS}
        element={<PortfolioLuckyBagsPage />}
      ></Route>
      <Route path={tifiRoutes.LIQUIDITY} element={<LiquidityPage />}></Route>
      <Route path={tifiRoutes.LOAN} element={<AssetPage />}></Route>
      <Route path={tifiRoutes.LOANDEPOSIT} element={<DepositPage />}></Route>
      <Route path={tifiRoutes.LOANWITHDRAW} element={<WithdrawPage />}></Route>
      <Route path={tifiRoutes.LOANBORROW} element={<BorrowPage />}></Route>
      <Route path={tifiRoutes.LOANREPAY} element={<RepayPage />}></Route>
      <Route path={tifiRoutes.LOTTERY} element={<LotteryPage />}></Route>
      <Route path={`${BASE_PATH}/*`} element={<HomePage />}></Route>
    </Routes>
  );
};

export default AppRoutes;
